/**
 * Animated water-drop icon for the priming state. Reused across
 * PumpCard (fleet view) and PumpDetail. Pure SVG + inline keyframes.
 */
export function PrimingIcon({
  size = 14,
  color = 'var(--aqua-priming)',
}: {
  size?: number;
  color?: string;
}) {
  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-block',
        width: size,
        height: size,
        lineHeight: 0,
        verticalAlign: 'middle',
      }}
      aria-hidden="true"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          animation: 'aquastar-spin 1.6s linear infinite',
          transformOrigin: '50% 50%',
        }}
      >
        <circle
          cx="8"
          cy="8"
          r="6.5"
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          strokeDasharray="14 26"
          strokeLinecap="round"
          opacity="0.7"
        />
      </svg>
      <svg
        width={size * 0.6}
        height={size * 0.6}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <path
          d="M8 1.5 C 5.5 5 3.5 7 3.5 9.5 a4.5 4.5 0 1 0 9 0 C 12.5 7 10.5 5 8 1.5 Z"
          fill={color}
        />
      </svg>
      <style>{`
        @keyframes aquastar-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </span>
  );
}
